import React from 'react'

export default function ProgressBar({ unfilledColor = '#D6D6DC', fillColor, percentage = 0 }) {
    return (
        <div style={{ width: '100%', height: 8, backgroundColor: unfilledColor, marginTop: '3%', borderRadius: 50 }}>
            <div style={{ height: '100%', backgroundColor: fillColor, borderRadius: 50, width: percentage }} />
        </div>
    )
}
